export const SEARCH_QUERY_MIN_LENGTH = 3;
